export default {
	install (Vue, options) {
		if (this.installed) {
			return
		}

		this.installed = true

		Vue.prototype.$toast = new Vue() // ToastsBus

		Vue.prototype.$toast.show = function (options, type) {
			if (typeof options === 'string') {
				this.$emit('toasts-open', {
					message: options,
					type
				})
			} else {
				this.$emit('toasts-open', {
					...options,
					type
				})
			}
		}

		Vue.prototype.$toast.closeAll = function () {
			this.$emit('toasts-close-all')
		}

		Vue.prototype.$toast.info = function (options) {
			this.$toast.show(options, 'info')
		}

		Vue.prototype.$toast.success = function (options) {
			this.$toast.show(options, 'success')
		}

		Vue.prototype.$toast.error = function (options) {
			this.$toast.show(options, 'error')
		}
	}
}
